module.exports = {
      id: "copy-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-147fd1e4cc1faf335e98b31c6ae31fe2.svg#copy",
      toString: function () {
        return this.url;
      }
    }